import { useEffect } from 'react';
import type { Money } from 'shared/util/money';
import type { PrivateItemPrice } from '@/domain';

export const useSyncPriceToParent = (privateItemPrice: PrivateItemPrice | undefined, setPrice?: (priceTotal: Money) => void) => {
    useEffect(() => {
        if (privateItemPrice && setPrice) {
            setPrice(privateItemPrice.total);
        }
    }, [privateItemPrice, setPrice]);
};
